import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=7dc70d8c&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=7dc70d8c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc70d8c",
  null
  
)

export default component.exports